var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9702 1.20117C22.7528 1.20117 1.49976 22.4574 1.49976 48.6748C1.49976 74.8922 22.7528 96.1484 48.9702 96.1484C75.1876 96.1484 96.4438 74.8953 96.4438 48.6748C96.4438 22.4543 75.1876 1.20117 48.9702 1.20117ZM48.9702 91.7846C25.1611 91.7846 5.86041 72.4839 5.86041 48.6748C5.86041 24.8657 25.1611 5.56183 48.9702 5.56183C72.7793 5.56183 92.08 24.8625 92.08 48.6716C92.08 72.4808 72.7793 91.7815 48.9702 91.7815V91.7846Z",
    fill: "url(#paint0_linear_264_578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0016 0C21.9385 0 0 21.9385 0 48.9984C0 76.0584 21.9385 97.9969 49.0016 97.9969C76.0647 97.9969 98 76.0584 98 48.9984C98 21.9385 76.0615 0 49.0016 0ZM49.0016 95.2553C36.6459 95.2553 25.0321 90.4419 16.2951 81.7081C7.55805 72.971 2.74781 61.3541 2.74781 49.0016C2.74781 36.649 7.55805 25.0321 16.2951 16.2951C25.029 7.55491 36.6459 2.74467 49.0016 2.74467C61.3573 2.74467 72.971 7.55491 81.7081 16.2919C90.4451 25.029 95.2553 36.6427 95.2553 48.9984C95.2553 61.3541 90.4451 72.9679 81.7081 81.7049C72.971 90.4388 61.3573 95.2522 49.0016 95.2522V95.2553Z",
    fill: "url(#paint1_linear_264_578)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M49.0018 96.6595C26.8747 96.6595 8.14618 82.2444 1.8457 62.3684C7.66515 82.933 26.5729 97.9988 49.0018 97.9988C71.4307 97.9988 90.3353 82.933 96.1547 62.3684C89.8542 82.2444 71.1257 96.6595 49.0018 96.6595Z",
    fill: "url(#paint2_linear_264_578)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6355 15.3625C73.6501 6.38021 61.7062 1.43164 49.0015 1.43164C36.2968 1.43164 24.353 6.38021 15.3676 15.3656C6.38217 24.3479 1.43359 36.2949 1.43359 48.9964C1.43359 61.698 6.38217 73.645 15.3644 82.6304C24.3498 91.6126 36.2968 96.5612 48.9984 96.5612C61.6999 96.5612 73.6469 91.6126 82.6323 82.6304C91.6146 73.6481 96.5632 61.7011 96.5632 48.9964C96.5632 36.2917 91.6146 24.3479 82.6323 15.3625H82.6355ZM81.708 81.7029C72.971 90.4368 61.3572 95.2502 49.0015 95.2502C36.6458 95.2502 25.0321 90.4368 16.295 81.7029C7.558 72.9659 2.74776 61.349 2.74776 48.9964C2.74776 36.6439 7.558 25.027 16.295 16.2899C25.0289 7.55291 36.6458 2.74267 49.0015 2.74267C61.3572 2.74267 72.971 7.55291 81.708 16.2899C90.4451 25.027 95.2553 36.6407 95.2553 48.9964C95.2553 61.3521 90.4451 72.9659 81.708 81.7029Z",
    fill: "url(#paint3_linear_264_578)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M96.1547 35.6304C90.3353 15.0658 71.4276 0 49.0018 0C26.576 0 7.66515 15.0658 1.8457 35.6304C8.14618 15.7575 26.8747 1.47766 49.0018 1.47766C71.1289 1.47766 89.8542 15.7543 96.1547 35.6304Z",
    fill: "url(#paint4_linear_264_578)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4694 17.5338C72.0625 9.12691 60.8889 4.49902 49.0016 4.49902C37.1143 4.49902 25.9407 9.12691 17.5338 17.5338C9.12691 25.9407 4.49902 37.1143 4.49902 49.0016C4.49902 60.8889 9.13006 72.0625 17.5338 80.4694C25.9376 88.8732 37.1143 93.501 49.0016 93.501C60.8889 93.501 72.0625 88.8732 80.4694 80.4694C88.8732 72.0625 93.501 60.8889 93.501 49.0016C93.501 37.1143 88.8732 25.9407 80.4694 17.5338ZM49.0016 90.7784C37.8437 90.7784 27.3492 86.4335 19.4579 78.5421C11.5666 70.6508 7.22168 60.1595 7.22168 49.0016C7.22168 37.8437 11.5666 27.3492 19.4579 19.4611C27.3492 11.5698 37.8406 7.22483 49.0016 7.22483C60.1626 7.22483 70.654 11.5698 78.5453 19.4611C86.4366 27.3524 90.7815 37.8437 90.7815 49.0016C90.7815 60.1595 86.4366 70.654 78.5453 78.5421C70.654 86.4335 60.1626 90.7784 49.0016 90.7784Z",
    fill: "url(#paint5_linear_264_578)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M81.0955 79.0142C72.522 87.418 61.122 92.0459 48.999 92.0459C36.8759 92.0459 25.4791 87.418 16.9055 79.0142C13.8905 76.0589 11.3533 72.7578 9.32861 69.2083C11.4256 73.3142 14.1797 77.1121 17.5343 80.4667C25.9381 88.8705 37.1148 93.4984 49.0021 93.4984C60.8894 93.4984 72.063 88.8705 80.4699 80.4667C83.8245 77.1121 86.5754 73.3174 88.6724 69.2083C86.6477 72.7609 84.1106 76.0589 81.0955 79.0142Z",
    fill: "url(#paint6_linear_264_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M88.6724 28.7892C86.5754 24.6832 83.8213 20.8853 80.4699 17.5307C72.063 9.12691 60.8862 4.49902 49.0021 4.49902C37.118 4.49902 25.9412 9.12691 17.5343 17.5307C14.1797 20.8853 11.4256 24.68 9.32861 28.7892C11.3533 25.2365 13.8905 21.9385 16.9055 18.9832C25.4791 10.5794 36.8759 5.95153 48.999 5.95153C61.122 5.95153 72.5188 10.5794 81.0955 18.9832C84.1106 21.9385 86.6477 25.2396 88.6724 28.7892Z",
    fill: "url(#paint7_linear_264_578)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4642 18.5407C71.3276 10.4042 60.5093 5.92407 49.0024 5.92407C37.4956 5.92407 26.6773 10.4042 18.5407 18.5407C10.4042 26.6773 5.92407 37.4956 5.92407 49.0024C5.92407 60.5093 10.4042 71.3276 18.5407 79.4642C26.6773 87.6007 37.4956 92.0808 49.0024 92.0808C60.5093 92.0808 71.3276 87.6007 79.4642 79.4642C87.6007 71.3276 92.0808 60.5093 92.0808 49.0024C92.0808 37.4956 87.6007 26.6773 79.4642 18.5407ZM78.5461 78.543C70.6548 86.4343 60.1635 90.7792 49.0024 90.7792C37.8414 90.7792 27.3501 86.4343 19.4588 78.543C11.5675 70.6517 7.22252 60.1603 7.22252 49.0024C7.22252 37.8446 11.5675 27.3501 19.4588 19.4619C27.3501 11.5706 37.8414 7.22567 49.0024 7.22567C60.1635 7.22567 70.6548 11.5706 78.5461 19.4619C86.4374 27.3532 90.7824 37.8446 90.7824 49.0024C90.7824 60.1603 86.4374 70.6548 78.5461 78.543Z",
    fill: "url(#paint8_linear_264_578)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.546 78.543C70.6547 86.4343 60.1634 90.7792 49.0023 90.7792C37.8413 90.7792 27.35 86.4343 19.4587 78.543C11.5673 70.6517 7.22241 60.1603 7.22241 49.0024C7.22241 37.8446 11.5673 27.3501 19.4587 19.4619C27.35 11.5706 37.8413 7.22567 49.0023 7.22567C60.1634 7.22567 70.6547 11.5706 78.546 19.4619C86.4373 27.3532 90.7823 37.8446 90.7823 49.0024C90.7823 60.1603 86.4373 70.6548 78.546 78.543Z",
    fill: "url(#paint9_radial_264_578)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3107 57.8H32.2867C33.2947 57 33.7987 56.024 33.7987 54.872V43.112C33.7987 41.944 33.2947 40.968 32.2867 40.184H43.6387L44.0467 44.336C43.6947 43.392 43.0547 42.64 42.1267 42.08C41.2147 41.52 40.2707 41.24 39.2947 41.24H36.7987V47.312H37.7827C38.5667 47.312 39.2787 47.104 39.9187 46.688C40.5747 46.272 41.0707 45.712 41.4067 45.008V50.672C41.0707 49.968 40.5747 49.408 39.9187 48.992C39.2787 48.576 38.5667 48.368 37.7827 48.368H36.7987V54.872C36.7987 56.024 37.3027 57 38.3107 57.8ZM55.3997 57.8H44.0477C45.0717 57 45.5837 56.024 45.5837 54.872V43.112C45.5837 41.944 45.0717 40.968 44.0477 40.184H50.0957C49.0717 40.968 48.5597 41.944 48.5597 43.112V56.72H51.0797C52.0557 56.72 52.9997 56.44 53.9117 55.88C54.8397 55.32 55.4797 54.576 55.8317 53.648L55.3997 57.8ZM62.7948 57.8H56.7468C57.7708 57 58.2828 56.024 58.2828 54.872V49.304L55.2348 43.04C54.7068 41.904 53.8668 40.952 52.7148 40.184H58.7388C58.3388 40.632 58.1388 41.128 58.1388 41.672C58.1388 41.976 58.2108 42.28 58.3548 42.584L60.6828 47.384L63.1788 42.728C63.3228 42.408 63.3948 42.088 63.3948 41.768C63.3948 41.176 63.1548 40.648 62.6748 40.184H66.9228C65.7548 40.904 64.8428 41.872 64.1868 43.088L61.2588 48.584V54.872C61.2588 55.448 61.3948 55.992 61.6668 56.504C61.9388 57.016 62.3148 57.448 62.7948 57.8Z",
    fill: "#5065A7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_578",
    x1: 103.442,
    y1: 137.837,
    x2: 53.7742,
    y2: 56.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_578",
    x1: 49.0016,
    y1: 0,
    x2: 49.0016,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_578",
    x1: 49.0018,
    y1: 62.3684,
    x2: 49.0018,
    y2: 98.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_578",
    x1: -0.0000445196,
    y1: 96.5644,
    x2: 0.31435,
    y2: 1.43164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_264_578",
    x1: 49.0018,
    y1: 35.6335,
    x2: 49.0018,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_264_578",
    x1: 0.0000352889,
    y1: 36.6868,
    x2: 0.31443,
    y2: 125.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_264_578",
    x1: 49.0021,
    y1: 66.7843,
    x2: 49.0021,
    y2: 94.1523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_264_578",
    x1: 49.0021,
    y1: 28.7892,
    x2: 49.0021,
    y2: 4.49902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_264_578",
    x1: 49.0024,
    y1: 92.0808,
    x2: 49.0024,
    y2: 5.92093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_264_578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6516 49.0024) rotate(90) scale(43.0784 42.4292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69896,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyButton);
export default __webpack_public_path__ + "static/media/fly-button.7026c36b674679aa948ed408e192e3fc.svg";
export { ForwardRef as ReactComponent };